import * as Types from '../../../graphql-types'

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
const defaultOptions = {} as const
export type ContentPolicyList_YiQueryQueryVariables = Types.Exact<{ [key: string]: never }>

export type ContentPolicyList_YiQueryQuery = {
  __typename?: 'Query'
  contentPolicyList?: {
    __typename?: 'ContentPolicyListResponse'
    contentPolicies?: Array<{
      __typename?: 'ContentPolicy'
      policyId?: string | null
      name?: string | null
    } | null> | null
  } | null
}

export const ContentPolicyList_YiQueryDocument = gql`
  query ContentPolicyList_YIQuery {
    contentPolicyList(limit: 1000) {
      contentPolicies {
        policyId
        name
      }
    }
  }
`

/**
 * __useContentPolicyList_YiQueryQuery__
 *
 * To run a query within a React component, call `useContentPolicyList_YiQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useContentPolicyList_YiQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContentPolicyList_YiQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useContentPolicyList_YiQueryQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ContentPolicyList_YiQueryQuery,
    ContentPolicyList_YiQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ContentPolicyList_YiQueryQuery, ContentPolicyList_YiQueryQueryVariables>(
    ContentPolicyList_YiQueryDocument,
    options,
  )
}
export function useContentPolicyList_YiQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ContentPolicyList_YiQueryQuery,
    ContentPolicyList_YiQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ContentPolicyList_YiQueryQuery,
    ContentPolicyList_YiQueryQueryVariables
  >(ContentPolicyList_YiQueryDocument, options)
}
// @ts-ignore
export function useContentPolicyList_YiQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ContentPolicyList_YiQueryQuery,
    ContentPolicyList_YiQueryQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ContentPolicyList_YiQueryQuery,
  ContentPolicyList_YiQueryQueryVariables
>
export function useContentPolicyList_YiQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ContentPolicyList_YiQueryQuery,
        ContentPolicyList_YiQueryQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ContentPolicyList_YiQueryQuery | undefined,
  ContentPolicyList_YiQueryQueryVariables
>
export function useContentPolicyList_YiQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ContentPolicyList_YiQueryQuery,
        ContentPolicyList_YiQueryQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ContentPolicyList_YiQueryQuery,
    ContentPolicyList_YiQueryQueryVariables
  >(ContentPolicyList_YiQueryDocument, options)
}
export type ContentPolicyList_YiQueryQueryHookResult = ReturnType<
  typeof useContentPolicyList_YiQueryQuery
>
export type ContentPolicyList_YiQueryLazyQueryHookResult = ReturnType<
  typeof useContentPolicyList_YiQueryLazyQuery
>
export type ContentPolicyList_YiQuerySuspenseQueryHookResult = ReturnType<
  typeof useContentPolicyList_YiQuerySuspenseQuery
>
export type ContentPolicyList_YiQueryQueryResult = Apollo.QueryResult<
  ContentPolicyList_YiQueryQuery,
  ContentPolicyList_YiQueryQueryVariables
>
